import React, {useState} from 'react';
import styled from 'styled-components';

import {CHETWODEBLUE, BITTERSWEET, OzRow, OzCol, OzCard, OzButton, OzTypo, OzInput} from "@ozwol/webui";

const Error = styled.div`
  height: 30px;
  color: ${BITTERSWEET};
`;

const FormNewPassword = ({onConfirm, error}) => {
  const [email, setEmail] = useState('');


  return (

    <OzCard>
      <OzTypo variant="h1c" color={CHETWODEBLUE}>Forgot password</OzTypo>
      <>Recover your account.</>

      <OzRow>
        <OzCol widthmd="12">
          <OzInput
            label={"Email"}
            name="email"
            type="email"
            width="100%"
            value={email}
            onChange={(val) => setEmail(val)}
            required
          />
        </OzCol>
        <OzCol widthmd="12">
          <OzButton variant={"chetwodeblue"} onClick={() => onConfirm({
            action: "forgot-password",
            params: {
              email: email
            }
          })}>Recover</OzButton>
        </OzCol>
        <OzCol widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </OzCol>
      </OzRow>
    </OzCard>
  )
}

export default FormNewPassword;
